import React, { useState } from "react";
import { signIn, fetchAuthSession } from 'aws-amplify/auth';
import { FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import { useFormFields } from "../libs/hooksLib";
import { LinkContainer } from "react-router-bootstrap";
import "./Login.css";

export default function Login(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [fields, handleFieldChange] = useFormFields({
    email: "",
    password: ""
  });

  function validateForm() {
    return fields.email.length > 0 && fields.password.length > 0;
  }

  async function handleSubmit(event) {
    event.preventDefault();

    setIsLoading(true);

    try {
      const { isSignedIn } = await signIn({ username: fields.email, password: fields.password });
      console.log('Sign in successful:', isSignedIn);
      
      // Fetch credentials from Identity Pool for IAM authentication
      const session = await fetchAuthSession({ forceRefresh: true });
      console.log('Credentials fetched:', session.credentials ? 'Yes' : 'No');
      
      props.userHasAuthenticated(true);
      
      // Redirect to the page user was trying to access, or home
      const redirect = new URLSearchParams(props.location.search).get('redirect');
      props.history.push(redirect || '/');
    } catch (e) {
      console.error('Login error:', e);
      alert(e.message);
      setIsLoading(false);
    }
  }

  return (
    <div className="Login">
      <form onSubmit={handleSubmit}>
        <FormGroup controlId="email" bsSize="large">
          <ControlLabel>Email</ControlLabel>
          <FormControl
            autoFocus
            type="email"
            value={fields.email}
            onChange={handleFieldChange}
          />
        </FormGroup>
        <FormGroup controlId="password" bsSize="large">
          <ControlLabel>Password</ControlLabel>
          <FormControl
            type="password"
            value={fields.password}
            onChange={handleFieldChange}
          />
        </FormGroup>
        <LoaderButton
          block
          type="submit"
          bsSize="large"
          isLoading={isLoading}
          disabled={!validateForm()}
          className="LoginButton"
        >
          Login
        </LoaderButton>
        <LinkContainer to="/forgotPassword">
          <LoaderButton
            block
            type="submit"
            bsSize="large">
            Forgot password
          </LoaderButton>
        </LinkContainer>
      </form>
    </div>
  );
}